module.exports = __webpack_public_path__ + "img/exercise.218f0370.png";